export function getUploadedFileURL(pathname: string) {
  return `/api/next/download-file/${pathname}`;
}
